import React from 'react';

/**
 * Shared Oxygen brand logo.
 * Uses the published PNG brand asset so light and dark themes stay consistent.
 */
const Logo = ({
  className = '',
  width = 'auto',
  height = 'auto',
  maxWidth = '180px',
  alt = 'Shared Oxygen',
}) => {
  const actualWidth = width === 'auto' ? maxWidth : width;
  const actualHeight = height === 'auto' ? undefined : height;

  return (
    <span
      className={`logo-shell ${className}`}
      style={{
        width: actualWidth,
        height: actualHeight,
        maxWidth,
        aspectRatio: actualHeight ? undefined : '1 / 1',
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'visible',
        background: 'transparent',
        border: 'none',
        boxShadow: 'none',
      }}
    >
      <img
        src="/logo-current.png?v=20261026b"
        alt={alt}
        className="logo"
        style={{
          width: '100%',
          height: actualHeight ? '100%' : 'auto',
          objectFit: 'contain',
          objectPosition: 'center',
          display: 'block',
        }}
      />
    </span>
  );
};

export default Logo;
